import React from 'react';
import { useMediaQuery } from '@mui/material';
import { UserRound } from 'lucide-react';

// Step "Datos personales"
const Step1Icon = ({ color }) => {
    const matches = useMediaQuery('(min-width:600px)');
    return <UserRound color={color} size={matches ? 25 : 20} strokeWidth={2.1} />;
};

export default Step1Icon;
